import { JetView } from 'webix-jet'; // Importing JetView from webix-jet for creating views
import { devConfig } from 'config/config'; // Importing development configuration
import Filter from 'jet-views/customers/reports/referralsReport/filterReferralsReports'; // Importing Filter component
import Table from 'jet-views/customers/reports/referralsReport/tableReferralsReports'; // Importing Table component

/**
 * BonusReportView class extends JetView to create a report view for bonuses.
 */
export default class BonusReportView extends JetView {
    /**
     * Configures the view layout and components.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const theme = this.app.config.theme; // Theme configuration

        // Toolbar configuration for pagination and export options
        const toolbar = {
            view: 'toolbar',
            id: 'toolbar',
            css: 'highlighted_header header6',
            paddingX: 5,
            paddingY: 5,
            height: 40,
            hidden: true, // Initially hidden
            cols: [
                {
                    view: 'select', // Dropdown for selecting number of items per page
                    options: ['10', '20', '50', '100'],
                    width: 70,
                    on: {
                        onChange: function () {
                            // Update pager size and refresh datatable on change
                            $$('datatableDetails').getPager().config.size = this.getValue() * 1;
                            $$('datatableDetails').refresh();
                        },
                    },
                },
                {
                    view: 'pager', // Pager for navigation
                    id: 'pagerA',
                    template:
                        '{common.first()}{common.prev()}&nbsp; {common.pages()}&nbsp; {common.next()}{common.last()}',
                    autosize: false,
                    height: 35,
                    size: devConfig.getDefaultDataFetch(), // Default fetch size from config
                },
                {
                    view: 'richselect', // Dropdown for export options
                    name: 'Export',
                    id: 'Export',
                    width: 120,
                    placeholder: _('Exportar'), // Placeholder text for localization
                    options: [
                        { id: '1', value: 'Excel' }, // Excel export option
                        { id: '2', value: 'PDF' }, // PDF export option
                    ],
                    on: {
                        onChange: function (value) {
                            // Handle export functionality based on selected value
                            var size = $$('datatableDetails').getPager().config.size; // Current page size
                            var page = $$('datatableDetails').getPage(); // Current page number
                            var first = size * page; // First item index
                            var last = first + size - 1; // Last item index

                            if (value == 1) {
                                // Excel export
                                var table = $$('datatableDetails');
                                for (var j = 0; j < table.config.columns.length; j++) {
                                    if (table.config.columns[j].exportType) {
                                        delete table.config.columns[j].format; // Remove format for export
                                    }
                                }
                                this.app.callEvent('export:data', [
                                    {
                                        NameReport:
                                            ($$('datatableDetails').count() > 0 ? '' : _('No hay datos - ')) +
                                            'Sesiones',
                                        TypeReport: 'Excel',
                                    },
                                ]);
                                webix.toExcel(table, {
                                    filter: function (obj) {
                                        // Filter data for export
                                        return (
                                            $$('datatableDetails').getIndexById(obj.id) >= first &&
                                            $$('datatableDetails').getIndexById(obj.id) <= last
                                        );
                                    },
                                    filename:
                                        'Virtualsoft - ' +
                                        new Date()
                                            .toLocaleString('en-GB', {
                                                hour12: true,
                                            })
                                            .replace(/^(\d{4})-(\d{2})-(\d{2})$/g, '$3/$2/$1')
                                            .replace(/[\/:]/g, '_')
                                            .toUpperCase() +
                                        ' - ' +
                                        ($$('datatableDetails').count() > 0 ? '' : _('No hay datos - ')) +
                                        'Sesiones',
                                    ignore: {
                                        detailTittle: true,
                                        ActionTittle: true,
                                    },
                                    footer: false,
                                });
                            } else {
                                if (value == 2) {
                                    // PDF export
                                    this.app.callEvent('export:data', [
                                        {
                                            NameReport:
                                                ($$('datatableDetails').count() > 0 ? '' : _('No hay datos - ')) +
                                                'Sesiones',
                                            TypeReport: 'PDF',
                                        },
                                    ]);
                                    webix.toPDF($$('datatableDetails'), {
                                        filter: function (obj) {
                                            // Filter data for export
                                            return (
                                                $$('datatableDetails').getIndexById(obj.id) >= first &&
                                                $$('datatableDetails').getIndexById(obj.id) <= last
                                            );
                                        },
                                        filename:
                                            'Virtualsoft - ' +
                                            new Date()
                                                .toLocaleString('en-GB', {
                                                    hour12: true,
                                                })
                                                .replace(/^(\d{4})-(\d{2})-(\d{2})$/g, '$3/$2/$1')
                                                .replace(/[\/:]/g, '_')
                                                .toUpperCase() +
                                            ' - ' +
                                            ($$('datatableDetails').count() > 0 ? '' : _('No hay datos - ')) +
                                            'Sesiones',
                                        autowidth: true,
                                        ignore: {
                                            detailTittle: true,
                                            ActionTittle: true,
                                        },
                                        footer: false,
                                    });
                                }
                            }
                            $$('Export').setValue(''); // Reset export selection
                        }.bind(this),
                    },
                },
            ],
        };

        // Second toolbar configuration for total data
        const toolbar2 = {
            view: 'toolbar',
            id: 'toolbar2',
            css: 'highlighted_header header6',
            paddingX: 5,
            paddingY: 5,
            height: 40,
            cols: [
                {
                    view: 'select', // Dropdown for selecting number of items per page
                    options: ['10', '20', '50', '100'],
                    width: 70,
                    on: {
                        onChange: function () {
                            // Update pager size and refresh datatable on change
                            $$('datatableTotal').getPager().config.size = this.getValue() * 1;
                            $$('datatableTotal').refresh();
                        },
                    },
                },
                {
                    view: 'pager', // Pager for navigation
                    id: 'pagerB',
                    template:
                        '{common.first()}{common.prev()}&nbsp; {common.pages()}&nbsp; {common.next()}{common.last()}',
                    autosize: false,
                    height: 35,
                    size: devConfig.getDefaultDataFetch(), // Default fetch size from config
                },
                {
                    view: 'richselect', // Dropdown for export options
                    name: 'Export',
                    id: 'Export',
                    width: 120,
                    placeholder: _('Exportar'), // Placeholder text for localization
                    options: [
                        { id: '1', value: 'Excel' }, // Excel export option
                        { id: '2', value: 'PDF' }, // PDF export option
                    ],
                    on: {
                        onChange: function (value) {
                            // Handle export functionality based on selected value
                            var size = $$('datatableTotal').getPager().config.size; // Current page size
                            var page = $$('datatableTotal').getPage(); // Current page number
                            var first = size * page; // First item index
                            var last = first + size - 1; // Last item index

                            if (value == 1) {
                                // Excel export
                                var table = $$('datatableTotal');
                                for (var j = 0; j < table.config.columns.length; j++) {
                                    if (table.config.columns[j].exportType) {
                                        delete table.config.columns[j].format; // Remove format for export
                                    }
                                }
                                this.app.callEvent('export:data', [
                                    {
                                        NameReport:
                                            ($$('datatableTotal').count() > 0 ? '' : _('No hay datos - ')) + 'Sesiones',
                                        TypeReport: 'Excel',
                                    },
                                ]);
                                webix.toExcel(table, {
                                    filter: function (obj) {
                                        // Filter data for export
                                        return (
                                            $$('datatableTotal').getIndexById(obj.id) >= first &&
                                            $$('datatableTotal').getIndexById(obj.id) <= last
                                        );
                                    },
                                    filename:
                                        'Virtualsoft - ' +
                                        new Date()
                                            .toLocaleString('en-GB', {
                                                hour12: true,
                                            })
                                            .replace(/^(\d{4})-(\d{2})-(\d{2})$/g, '$3/$2/$1')
                                            .replace(/[\/:]/g, '_')
                                            .toUpperCase() +
                                        ' - ' +
                                        ($$('datatableTotal').count() > 0 ? '' : _('No hay datos - ')) +
                                        'Sesiones',
                                    ignore: {
                                        detailTittle: true,
                                        ActionTittle: true,
                                    },
                                    footer: false,
                                });
                            } else {
                                if (value == 2) {
                                    // PDF export
                                    this.app.callEvent('export:data', [
                                        {
                                            NameReport:
                                                ($$('datatableTotal').count() > 0 ? '' : _('No hay datos - ')) +
                                                'Sesiones',
                                            TypeReport: 'PDF',
                                        },
                                    ]);
                                    webix.toPDF($$('datatableTotal'), {
                                        filter: function (obj) {
                                            // Filter data for export
                                            return (
                                                $$('datatableTotal').getIndexById(obj.id) >= first &&
                                                $$('datatableTotal').getIndexById(obj.id) <= last
                                            );
                                        },
                                        filename:
                                            'Virtualsoft - ' +
                                            new Date()
                                                .toLocaleString('en-GB', {
                                                    hour12: true,
                                                })
                                                .replace(/^(\d{4})-(\d{2})-(\d{2})$/g, '$3/$2/$1')
                                                .replace(/[\/:]/g, '_')
                                                .toUpperCase() +
                                            ' - ' +
                                            ($$('datatableTotal').count() > 0 ? '' : _('No hay datos - ')) +
                                            'Sesiones',
                                        autowidth: true,
                                        ignore: {
                                            detailTittle: true,
                                            ActionTittle: true,
                                        },
                                        footer: false,
                                    });
                                }
                            }
                            $$('Export').setValue(''); // Reset export selection
                        }.bind(this),
                    },
                },
            ],
        };

        // Left section containing filter, table, and toolbars
        const left = {
            height: 820,
            rows: [Filter, Table, toolbar, toolbar2],
        };

        // Main configuration for the view
        return {
            id: 'a5',
            type: 'clean',
            view: 'form',
            scrollY: true,
            css: 'scrolling',
            rows: [
                {
                    responsive: 'a5',
                    type: 'wide',
                    cols: [left],
                },
            ],
        };
    }

    /**
     * Initializes the view and modifies UI based on screen size.
     * @param {Object} grid - The grid object passed during initialization.
     */
    init(grid) {
        webix.ready(function () {
            // Adjust UI for smaller screens
            if (screen.width < 500 || screen.height < 500) {
                var childs = $$('toolbar').getChildViews(); // Get child views of the first toolbar
                $$('toolbar').removeView(childs[2]); // Remove the export dropdown
                $$('pagerA').define('group', 1); // Group pager items
                var childs2 = $$('toolbar2').getChildViews(); // Get child views of the second toolbar
                $$('toolbar2').removeView(childs2[2]); // Remove the export dropdown
                $$('pagerB').define('group', 1); // Group pager items
            }
        });
    }
}

// FILE DOCUMENTED
